import React, { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import '../styles/card.css';
import Connect from './Connect';
import Market from './Market';
import MarketMarquee from './MarketMarquee';

const MyCard = ({ user }) => {
  const [userData, setUserData] = useState(null);
  const [applicationNumber, setApplicationNumber] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchUserData = async () => {
      if (!user?.uid) return;
      try {
        const userDoc = await getDoc(doc(db, 'bit', user.uid));
        if (userDoc.exists()) {
          setUserData(userDoc.data());
        } else {
          setError('User not found.');
        }
      } catch (err) {
        console.error('Error fetching user data:', err);
        setError('Failed to load user data.');
      }
    };

    fetchUserData();
  }, [user]);

  return (
    <div className="transactions-container" id="card">
      <MarketMarquee />
      <div>
        <Market />
      </div>

      {applicationNumber && (
        <div className="application-info">Wallet link submitted!</div>
      )}

      {error && <div className="error-message">{error}</div>}

      {userData ? (
        <div className="card-section-container">
          <Connect
            user={user}
            userData={userData}
            setUserData={setUserData}
            setApplicationNumber={setApplicationNumber}
          />
        </div>
      ) : (
        !error && <div>Loading user data...</div>
      )}
    </div>
  );
};

export default MyCard;
